export const update = {
  form: {
    code: 'Code',
    name: 'Name',
    update: 'Update',
    requireCode: 'Please input operator code',
    requireName: 'Please input operator name',
  },
  pageHeader: {
    title: 'Update Operator',
    back: 'Back',
  },
}
